import React, { useState } from "react";
import { doPost } from "../../API/apis";
import { useStateGlobalContext } from "../../contexts/GlobalContext";
import dayjs from "dayjs";
import Notification from "../Notification/Notification";
import ProductCheckout from "../ProductCheckout/ProductCheckout";
import { discountCalulator } from "../../utils/validator";
import { Form, Input, Row, Col } from "antd";

const GuestCheckoutDrawer = ({ visible, onClose }) => {
  const [saving, setSaving] = useState(false);
  const { getGuestInvoices } = useStateGlobalContext();
  const currentDate = dayjs().format("MM/DD/YYYY");

  const handleCheckout = async ({
    productList,
    totalPriceBeforeTax,
    totalPriceAfterTax,
    discount,
    discountApplied,
    calcTax,
    form,
  }) => {
    setSaving(true);
    
    try {
      const discountValue = discountApplied
        ? discountCalulator(discount, totalPriceBeforeTax)
        : 0;

      const data = {
        patient_name: form.getFieldValue("customer_name"),
        product_details: productList,
        price: totalPriceBeforeTax,
        discount: discount,
        discounted_amount: discountValue,
        tax: calcTax(totalPriceBeforeTax),
        grand_total: totalPriceAfterTax,
        notes: form.getFieldValue("notes"),
        payment_method: form.getFieldValue("payment_method"),
      };

      const response = await doPost(`/inventory/add-guest/`, data);
      if (response.status === 201) {
        Notification.success("Guest Invoice Created Successfully");
        getGuestInvoices();
        return true;
      }
    } catch (error) {
      Notification.error("Something went Wrong");
      throw error;
    } finally {
      setSaving(false);
    }
  };

  return (
    <ProductCheckout
      visible={visible}
      onClose={onClose}
      title="Guest Checkout"
      onCheckout={handleCheckout}
      isGuest={true}
      showStrength={false}
      saving={saving}
    >
      {/* Guest Information Header */}
      <p>Date: {currentDate}</p>
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="customer_name" label="Customer Name">
            <Input placeholder="Customer Name" />
          </Form.Item>
        </Col>
        
       
      </Row>
    </ProductCheckout>
  );
};

export default GuestCheckoutDrawer;
